import { RouteConstant } from "./RouteConstant";
import VesselScreen from "../screens/Vessel/VesselScreen";
import VesselDetailsScreen from "../screens/Vessel/VesselDetailsScreen";
import InspectionHistory from "../screens/InspectionHistory/InspectionHistory";
import ChapterProgress from "../screens/ChapterProgress/ChapterProgress";
import QuestionProgress from "../screens/QuestionProgress.js/QuestionProgress";
import QuestionDetailScreen from "../screens/QuestionProgress.js/QuestionDetailScreen";
import PdfGenerator from "../screens/InspectionHistory/PdfGenerator";
import DocumentScreen from "../screens/Documents/DocumentScreen";
import QuestionExclude from "../screens/InspectionHistory/QuestionExclude";
import UsersList from "../screens/User/UsersList";
import DashboardLayout from "../screens/Dashboard/DashboardLayout";
import QuestionForm from "../screens/Master/Questions/QuestionForm";
import QuestionList from "../screens/Master/Questions/QuestionList";
import ChapterScreen from "../screens/Master/Chapter/ChapterScreen";
import OcimfScreen from "../screens/Vessel/ocimfvessel";
import DemoRegistration from "../screens/Demo/DemoRegistration";
import Payment from "../components/Payment";
import ForgotPassword from "../screens/FortgotPassword/ForgotPassword";
import RestrictedRoute from "./RestrictedRoute";
import { Navigate } from "react-router-dom";
import ExploreProductsScreen from "../screens/ExploreProducts/ExploreProductsScreen";

export const PublicRoutes = [
  { path: RouteConstant.FORGOTPASSWORD, element: <ForgotPassword /> },
  { path: RouteConstant.DEMO, element: <DemoRegistration /> },
  { path: RouteConstant.PAYMENT, element: <Payment /> },
  { path: RouteConstant.OURAPPS, element: <ExploreProductsScreen /> },
];

export const SuperAdminRoutes = [
  { path: RouteConstant.ROOT, element: <Navigate to={RouteConstant.DASHBOARD} replace /> },
  { path: RouteConstant.DASHBOARD, element: <DashboardLayout /> },
  { path: RouteConstant.QUESTIONFORM, element: <QuestionForm /> },
  { path: RouteConstant.QUESTIONLIST, element: <QuestionList /> },
  { path: RouteConstant.CHAPTER, element: <ChapterScreen /> },
  { path: RouteConstant.USERS, element: <UsersList /> },
  { path: RouteConstant.VESSEL, element: <VesselScreen /> },
  { path: RouteConstant.VESSELDETAILS, element: <VesselDetailsScreen /> },
  { path: RouteConstant.INSPECTIONHISTORY, element: <InspectionHistory /> },
  { path: RouteConstant.CHAPTERPROGRESS, element: <ChapterProgress /> },
  { path: RouteConstant.QUESTIONPROGRESS, element: <QuestionProgress /> },
  { path: RouteConstant.QUESTIONDETAIL, element: <QuestionDetailScreen /> },
  { path: RouteConstant.OCIMFVESSEL, element: <OcimfScreen /> },
  { path: RouteConstant.INSPECTIONREPORT, element: <PdfGenerator /> },
  { path: RouteConstant.DOCUMENTS, element: <DocumentScreen /> }
];

export const ManagerRoutes = [
  { path: RouteConstant.ROOT, element: <Navigate to={RouteConstant.USERS} replace /> },
  { path: RouteConstant.USERS, element: <UsersList /> },
  { path: RouteConstant.VESSEL, element: <VesselScreen /> },
  { path: RouteConstant.VESSELDETAILS, element: <VesselDetailsScreen /> },
  { path: RouteConstant.INSPECTIONHISTORY, element: <InspectionHistory /> },
  { path: RouteConstant.CHAPTERPROGRESS, element: <ChapterProgress /> },
  { path: RouteConstant.QUESTIONPROGRESS, element: <QuestionProgress /> },
  { path: RouteConstant.QUESTIONDETAIL, element: <QuestionDetailScreen /> },
  { path: RouteConstant.INSPECTIONREPORT, element: <PdfGenerator /> },
  { path: RouteConstant.DOCUMENTS, element: <DocumentScreen /> }
];

export const InspectorRoutes = [
  { path: RouteConstant.ROOT, element: <Navigate to={RouteConstant.VESSEL} replace /> },
  { path: RouteConstant.VESSEL, element: <VesselScreen /> },
  { path: RouteConstant.VESSELDETAILS, element: <VesselDetailsScreen /> },
  { path: RouteConstant.INSPECTIONHISTORY, element: <InspectionHistory /> },
  { path: RouteConstant.CHAPTERPROGRESS, element: <ChapterProgress /> },
  { path: RouteConstant.QUESTIONPROGRESS, element: <QuestionProgress /> },
  { path: RouteConstant.QUESTIONDETAIL, element: <QuestionDetailScreen /> },
  { path: RouteConstant.INSPECTIONREPORT, element: <PdfGenerator /> },
  { path: RouteConstant.DOCUMENTS, element: <DocumentScreen /> },
  {
    path: RouteConstant.EXCLUDEQUESTIONS,
    element: (
      <RestrictedRoute allowedSubscriptions={['Premium']} restrictionKey="questionChapterLimit">
        <QuestionExclude />
      </RestrictedRoute>
    ),
  },
];